import React from 'react';

interface SplitByPriorityToggleProps {
    on: boolean;
    onToggle: (next: boolean) => void;
}

export function SplitByPriorityToggle({
    on,
    onToggle
}: SplitByPriorityToggleProps): React.ReactElement {
    return (
        <div
            role="button"
            tabIndex={0}
            className="flex items-center justify-between px-4 py-2.5 cursor-pointer hover:bg-gray-50 transition-colors select-none"
            onClick={() => onToggle(!on)}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onToggle(!on);
                }
            }}
            aria-pressed={on}
            aria-label="Split by priority"
        >
            <div className="flex flex-col">
                <span className="text-[12.5px] font-semibold text-gray-700 leading-tight">
                    Split by priority
                </span>
                <span className="text-[10.5px] text-gray-500 leading-tight mt-0.5">
                    Extreme → High → Normal sections
                </span>
            </div>

            {/* Pill switch: ~30×17px, knob 13px */}
            <div
                className={`relative flex-shrink-0 rounded-full transition-colors duration-200 ${
                    on ? 'bg-gray-900' : 'bg-gray-300'
                }`}
                style={{ width: 30, height: 17 }}
                aria-hidden="true"
            >
                <span
                    className="absolute top-[2px] rounded-full bg-white shadow-sm transition-transform duration-200"
                    style={{
                        width: 13,
                        height: 13,
                        left: 2,
                        transform: on ? 'translateX(13px)' : 'translateX(0)'
                    }}
                />
            </div>
        </div>
    );
}
